<template>
    <div>
        <van-form validate-first scroll-to-error @submit="onSubmit">
            <DictSelect
              v-model="attendanceDetail.schoolId"
              name="school"
              label="上课校区"
              placeholder="请选择上课校区"
              required
              :rules="[{ required: true, message: '请选择上课校区' }]"
              :columns="schoolList"
              :column-names="schoolFieldName"
              @confirm="onSchoolConfirm"
            />

            <DictSelect
              v-model="attendanceDetail.classroomId"
              name="classroom"
              label="教室"
              placeholder="请选择教室"
              :columns="classroomList"
              :column-names="classroomFieldName"
              @confirm="onClassroomConfirm"
            />

            <DictSelect
              v-model="attendanceDetail.periodsNumber"
              name="period"
              label="期数"
              placeholder="请选择期数"
              required
              :rules="[{ required: true, message: '请选择期数' }]"
              :columns="semesterList"
              :column-names="dictFieldName"
              @confirm="(data) => { attendanceDetail.semesterName = data.label; attendanceDetail.periodsNumber = data.value }"
            />

            <DictSelect
              v-model="attendanceDetail.teachingMethod"
              name="teachingMethod"
              label="上课方式"
              placeholder="请选择上课方式"
              required
              :rules="[{ required: true, message: '请选择上课方式' }]"
              :columns="teachingMethodList"
              :column-names="dictFieldName"
              @confirm="(data) => { attendanceDetail.teachingMethodName = data.label; attendanceDetail.teachingMethod = data.value }"
            />

            <van-field v-model="attendanceDetail.classDate" name="classDate" label="上课日期" placeholder="请选择上课日期" required
                :rules="[{ required: true, message: '请选择上课日期' }]" readonly clickable
                @click="showDatePicker = true" />
            <div v-if="attendanceDetail.classDates.length > 3" class="date-preview">
                {{ attendanceDetail.classDate }}
            </div>
            <van-calendar :show="showDatePicker" :default-date="[]" :min-date="calendarMinDate"
                :lazy-render="false" type="multiple" position="bottom" @confirm="onDateConfirm"
                @close="showDatePicker = false" />

            <van-field v-model="attendanceDetail.startTime" name="startTime" label="上课开始时间" placeholder="请选择开始时间" required
                :rules="[{ required: true, message: '请选择上课开始时间' }]" readonly clickable
                @click="showStartTimePicker = true; startTimeDefault = attendanceDetail.startTime.split(':') || ['12', '00']" />
            <van-popup v-model:show="showStartTimePicker" position="bottom">
                <van-time-picker v-if="showStartTimePicker" v-model="startTimeDefault" @confirm="onStartTimeConfirm"
                    @cancel="showStartTimePicker = false" />
            </van-popup>

            <van-field v-model="attendanceDetail.endTime" name="endTime" label="上课结束时间" placeholder="请选择结束时间" required
                :rules="[{ required: true, message: '请选择上课结束时间' }]" readonly clickable
                @click="showEndTimePicker = true; endTimeDefault = attendanceDetail.endTime.split(':') || ['13', '00']" />
            <van-popup v-model:show="showEndTimePicker" position="bottom">
                <van-time-picker v-if="showEndTimePicker" v-model="endTimeDefault" @confirm="onEndTimeConfirm"
                    @cancel="showEndTimePicker = false" />
            </van-popup>

            <van-field v-model="attendanceDetail.teacherName" name="teacherName" label="上课教师" placeholder="请选择上课教师" required
                :rules="[{ required: true, message: '请选择上课教师' }]" readonly clickable
                @click="showTeacherPicker = true" />
            <van-popup v-model:show="showTeacherPicker" position="bottom">
                <div style="height: 80vh; overflow-y: auto;">
                    <van-search v-model="teacherSearchQuery" placeholder="搜索老师姓名" show-action
                        @update:model-value="filterTeachers" @cancel="showTeacherPicker = false" />
                    <van-cell v-for="teacher in filteredTeacherList" :key="teacher.userId" :title="teacher.nickName"
                        @click="selectTeacher(teacher)" />
                </div>
            </van-popup>

            <van-field v-model="attendanceDetail.courseName" name="courseName" label="课程" placeholder="请选择课程" required
                :rules="[{ required: true, message: '请选择课程' }]" readonly clickable
                @click="showCoursePicker = true" />
            <van-popup v-model:show="showCoursePicker" position="bottom">
                <div style="height: 80vh; overflow-y: auto;">
                    <van-search v-model="courseSearchQuery" placeholder="搜索课程名称" show-action
                        @update:model-value="filterCourse" @cancel="showCoursePicker = false" />
                    <van-cell v-for="course in filteredCourseList" :key="course.courseId" :title="course.courseName"
                        @click="onCourseConfirm(course)" />
                </div>
            </van-popup>

            <van-field label="是否跨校区">
                <template #input>
                    <van-switch v-model="attendanceDetail.isTransCampus" />
                </template>
            </van-field>

            <van-field v-model="attendanceDetail.overClassHour" label="加班课时" placeholder="请输入加班课时数" type="number" />

            <van-field v-model="attendanceDetail.studentNames" name="studentNames" label="上课学员" placeholder="请选择学员" required
                :rules="[{ required: true, message: '请选择上课学员' }]" readonly clickable
                @click="showStudent" />

            <van-popup v-model:show="showStudentPicker" position="bottom">
                <div style="height: 80vh; overflow-y: auto;">
                    <van-search v-model="studentSearchQuery" placeholder="搜索学生姓名" show-action
                        @update:model-value="filterStudents" @cancel="showStudentPicker = false" />

                    <div v-if="attendanceDetail.studentList.length" class="selected-students-panel">
                        <div class="selected-students-title">已选学员</div>
                        <div class="selected-students-list">
                            <div v-for="student in attendanceDetail.studentList" :key="student.studentId"
                                class="selected-student-item">
                                <span>{{ student.studentName || `学员${student.studentId}` }}</span>
                                <van-icon v-if="!isRequiredStudent(student.studentId)" name="cross"
                                    @click="removeStudent(student.studentId)" />
                            </div>
                        </div>
                    </div>

                    <div v-if="studentLoading" style="text-align: center; padding: 20px;">
                        <van-loading type="spinner" />
                        <p style="margin-top: 8px; color: #666;">加载学生列表中...</p>
                    </div>

                    <van-cell v-for="student in filteredStudentList" :key="student.studentId" :title="student.studentName"
                        :disabled="student.isLocked === 1" @click="selectStudent(student)">
                        <template #label>
                            <van-tag v-if="student.isLocked === 1" type="danger" plain style="margin-top: 2px;">已锁定</van-tag>
                        </template>
                    </van-cell>
                </div>
            </van-popup>

            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">
                    保存
                </van-button>
            </div>

            <van-overlay :show="loading">
                <div class="loading-wrapper">
                    <van-loading size="24px">提交中...</van-loading>
                </div>
            </van-overlay>

            <ScheduleConflictPopup v-model:show="conflictVisible" :message="conflictMessage" :data="conflictData" />
        </van-form>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { getScheduleCourseListByStudent, addScheduleForStudent, getStudentListByCourseH5, getClassroomList } from '@/api/schedule'
import { getSchoolDicts } from '@/api/dict'
import { getTeacherList } from '@/api/user'
import { getStudentDetail } from '@/api/crm'
import { useDict } from '@/utils/dict'
import DictSelect from '@/components/DictSelect.vue'
import ScheduleConflictPopup from '@/components/ScheduleConflictPopup.vue'

function createAttendanceDetail() {
  return { startTime: '', endTime: '', isTransCampus: false, overClassHour: 0, classDate: '', classDates: [], studentList: [], studentNames: '', schoolName: '', semesterName: '', teachingMethodName: '' }
}

const route = useRoute()
const router = useRouter()
const { teaching_method: teachingMethodList, semester_list: semesterList, loadDicts } = useDict('teaching_method', 'semester_list')
const loading = ref(false)
const courseId = ref(null)
const studentId = ref('')
const conflictVisible = ref(false)
const conflictData = ref([])
const conflictMessage = ref('')
const calendarMinDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
const attendanceDetail = reactive(createAttendanceDetail())
const schoolFieldName = { text: 'schoolName', value: 'schoolId' }
const classroomFieldName = { text: 'classroomName', value: 'classroomId' }
const dictFieldName = { text: 'dictLabel', value: 'dictValue' }
const courseSearchQuery = ref('')
const showDatePicker = ref(false)
const showStartTimePicker = ref(false)
const showEndTimePicker = ref(false)
const showTeacherPicker = ref(false)
const showCoursePicker = ref(false)
const showStudentPicker = ref(false)
const teacherList = ref([])
const studentList = ref([])
const filteredStudentList = ref([])
const courseList = ref([])
const filteredCourseList = ref([])
const studentLoading = ref(false)
const studentSearchQuery = ref('')
const startTimeDefault = ref(['12', '00'])
const endTimeDefault = ref(['13', '00'])
const teacherSearchQuery = ref('')
const filteredTeacherList = ref([])
const schoolList = ref([])
const classroomList = ref([])

onMounted(() => {
  Object.assign(attendanceDetail, createAttendanceDetail())
  courseId.value = route.query.courseId || null
  studentId.value = route.query.studentId || ''
  getCourseList()
  getTeachers()
  getOtherDicts()
  initStudent()
})

function initStudent() {
  if (!studentId.value) {
    message.error('缺少学员信息')
    return
  }
  attendanceDetail.studentList = [{ studentId: studentId.value }]
  syncStudentNames()
  getStudentDetail(studentId.value).then(detail => {
    const studentName = detail?.studentName || ''
    attendanceDetail.studentList = [{ studentId: studentId.value, studentName }]
    syncStudentNames()
  }).catch(() => {
    message.error('获取学员信息失败')
  })
}

function syncStudentNames() {
  const uniqueStudents = []
  const studentMap = new Map()
  attendanceDetail.studentList.forEach(student => {
    const key = String(student.studentId)
    if (!studentMap.has(key)) {
      studentMap.set(key, { ...student, studentId: student.studentId })
      uniqueStudents.push(studentMap.get(key))
      return
    }
    const existing = studentMap.get(key)
    if (!existing.studentName && student.studentName) {
      existing.studentName = student.studentName
    }
  })
  const requiredIndex = uniqueStudents.findIndex(student => isRequiredStudent(student.studentId))
  if (requiredIndex > 0) {
    const [requiredStudent] = uniqueStudents.splice(requiredIndex, 1)
    uniqueStudents.unshift(requiredStudent)
  }
  attendanceDetail.studentList = uniqueStudents
  attendanceDetail.studentNames = uniqueStudents.map(student => student.studentName || ('学员' + student.studentId)).join('、')
}

function isRequiredStudent(targetStudentId) {
  return String(targetStudentId) === String(studentId.value)
}

function getOtherDicts() {
  loadDicts()
  getSchoolDicts().then(res => {
    schoolList.value = res
    if (res && res.length === 1) {
      const school = res[0]
      attendanceDetail.schoolName = school.schoolName
      attendanceDetail.schoolId = school.schoolId
      loadClassrooms(school.schoolId)
    }
  })
}

function onSchoolConfirm({ value, label }) {
  attendanceDetail.schoolId = value
  attendanceDetail.schoolName = label
  attendanceDetail.classroomId = undefined
  attendanceDetail.classroomName = ''
  loadClassrooms(value)
}

function loadClassrooms(schoolId) {
  if (!schoolId) {
    classroomList.value = []
    return
  }
  getClassroomList({ schoolId, status: '1' }).then(response => {
    classroomList.value = response || []
  })
}

function onClassroomConfirm({ value, label }) {
  attendanceDetail.classroomId = value
  attendanceDetail.classroomName = label
}

function onDateConfirm(selectedDates) {
  const dates = Array.isArray(selectedDates) ? selectedDates : [selectedDates]
  const formattedDates = dates.filter(Boolean).map(date => formatDate(date)).sort()
  attendanceDetail.classDates = formattedDates
  attendanceDetail.classDate = formattedDates.join('、')
  showDatePicker.value = false
}

function formatDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return year + '-' + month + '-' + day
}

function getCourseList() {
  getScheduleCourseListByStudent({ studentId: studentId.value }).then(response => {
    courseList.value = response
    filteredCourseList.value = response
  })
}

function getTeachers() {
  getTeacherList().then(response => {
    teacherList.value = response
    filteredTeacherList.value = response
    if (response && response.length === 1) {
      const teacher = response[0]
      attendanceDetail.teacherName = teacher.nickName
      attendanceDetail.teacherId = teacher.userId
    }
  })
}

function onStartTimeConfirm(time) {
  attendanceDetail.startTime = time.selectedValues[0] + ':' + time.selectedValues[1]
  showStartTimePicker.value = false
}

function onEndTimeConfirm(time) {
  attendanceDetail.endTime = time.selectedValues[0] + ':' + time.selectedValues[1]
  showEndTimePicker.value = false
}

function filterTeachers() {
  const query = teacherSearchQuery.value
  filteredTeacherList.value = teacherList.value.filter(teacher => teacher.nickName.includes(query))
}

function filterCourse() {
  const query = courseSearchQuery.value
  filteredCourseList.value = courseList.value.filter(course => course.courseName.includes(query))
}

function selectTeacher(teacher) {
  attendanceDetail.teacherName = teacher.nickName
  attendanceDetail.teacherId = teacher.userId
  showTeacherPicker.value = false
}

function onCourseConfirm(selectCourse) {
  courseId.value = selectCourse.courseId
  attendanceDetail.courseId = selectCourse.courseId
  attendanceDetail.courseName = selectCourse.courseName
  attendanceDetail.subject = selectCourse.subject
  attendanceDetail.grade = selectCourse.grade
  attendanceDetail.teachingModel = selectCourse.teachingModel
  showCoursePicker.value = false
}

function showStudent() {
  if (!attendanceDetail.courseId || !attendanceDetail.startTime || !attendanceDetail.endTime) {
    message.warning('请先选择课程及上课时间')
    return
  }
  const params = { courseId: attendanceDetail.courseId, teachingModel: attendanceDetail.teachingModel, grade: attendanceDetail.grade, subject: attendanceDetail.subject, startTime: attendanceDetail.startTime, endTime: attendanceDetail.endTime }
  studentLoading.value = true
  showStudentPicker.value = true
  getStudentListByCourseH5(params).then(response => {
    studentList.value = response || []
    filteredStudentList.value = response || []
  }).finally(() => {
    studentLoading.value = false
  })
}

function filterStudents() {
  const query = studentSearchQuery.value
  filteredStudentList.value = studentList.value.filter(student => student.studentName.includes(query))
}

function selectStudent(student) {
  if (student.isLocked === 1) {
    message.warning('该学员已锁定，需解锁审核通过后才能排课')
    return
  }
  const exists = attendanceDetail.studentList.some(item => String(item.studentId) === String(student.studentId))
  if (!exists) {
    attendanceDetail.studentList.push(student)
    syncStudentNames()
  }
  showStudentPicker.value = false
}

function removeStudent(targetStudentId) {
  if (isRequiredStudent(targetStudentId)) {
    message.warning('当前学员必须保留')
    return
  }
  attendanceDetail.studentList = attendanceDetail.studentList.filter(student => String(student.studentId) !== String(targetStudentId))
  syncStudentNames()
}

function convertTimeToMinutes(timeStr) {
  if (!timeStr) return 0
  const [hours, minutes] = timeStr.split(':').map(Number)
  return hours * 60 + (minutes || 0)
}

function onSubmit() {
  if (!studentId.value) {
    message.error('缺少学员信息')
    return
  }
  const startMinutes = convertTimeToMinutes(attendanceDetail.startTime)
  const endMinutes = convertTimeToMinutes(attendanceDetail.endTime)
  if (endMinutes <= startMinutes) {
    message.error('上课结束时间必须大于开始时间')
    return
  }
  if (!attendanceDetail.studentList.some(student => isRequiredStudent(student.studentId))) {
    message.error('当前学员必须保留')
    return
  }
  loading.value = true
  const baseParam = { teachingModel: attendanceDetail.teachingModel, subject: attendanceDetail.subject, grade: attendanceDetail.grade, courseName: attendanceDetail.courseName, schoolId: attendanceDetail.schoolId, classroomId: attendanceDetail.classroomId, periodsNumber: attendanceDetail.periodsNumber, teachingMethod: attendanceDetail.teachingMethod, classDates: attendanceDetail.classDates, classTimes: [attendanceDetail.startTime, attendanceDetail.endTime], teacherId: attendanceDetail.teacherId, courseId: courseId.value, isTransCampus: attendanceDetail.isTransCampus ? 1 : 0, overClassHour: attendanceDetail.overClassHour, studentIds: attendanceDetail.studentList.map(student => student.studentId), classPeriod: 1, dayOfWeek: '' }
  addScheduleForStudent(baseParam).then(() => {
    message.success('保存成功！')
    router.back()
  }).catch(err => {
    if (err && err.data && Array.isArray(err.data) && err.data.length > 0) {
      conflictData.value = err.data
      conflictMessage.value = err.msg || '存在排课时间冲突，冲突详情如下：'
      conflictVisible.value = true
    }
  }).finally(() => {
    loading.value = false
  })
}
</script>

<style scoped>
.van-popup--bottom {
    background-color: #fff;
}

.van-search {
    padding: 10px 16px;
}

.van-cell {
    border-bottom: 1px solid #ebedf0;
}

.loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.date-preview {
    margin: -6px 16px 10px;
    padding: 10px 12px;
    border-radius: 8px;
    background: #f8fafc;
    color: #64748b;
    font-size: 12px;
    line-height: 1.5;
    word-break: break-all;
}

.selected-students-panel {
    padding: 8px 16px 12px;
    border-bottom: 1px solid #f1f5f9;
}

.selected-students-title {
    margin-bottom: 8px;
    font-size: 12px;
    color: #64748b;
}

.selected-students-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.selected-student-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 999px;
    background: #f8fafc;
    color: #0f172a;
    font-size: 12px;
}

</style>
